export default {
  MAX_ATTACHMENT_SIZE: 5000000,
  s3: {
    REGION: "us-east-1",
    BUCKET: 'sawbo-videos',

    VIDEO_BUCKET: 'sawbo-content/video',
    VIDEO_THUMBNAILS_BUCKET:'sawbo-content/videoThumbnails'
    
  },
  apiGateway: {
     URL: "https://vm63z2fss4.execute-api.us-east-1.amazonaws.com/dev",
      PRODURL:"https://4ict6dhhr1.execute-api.us-east-1.amazonaws.com/prod",  
    // PRODURL:"https://api.pointbluetech.org",
     REGION: "us-east-1"
  },
  cognito: {
      USER_POOL_ID: 'us-east-1_qh0byTDi0',
      APP_CLIENT_ID: '11pjelc8p9g4mhgo9tdlq665od',
      REGION: 'us-east-1',
      IDENTITY_POOL_ID: 'us-east-1:9c4fbaa3-6579-469c-b973-cdf3e434319e'
    },
    googleMap:
    {
      GOOGLE_API_KEY:'AIzaSyAIHn7NGcfX9YdVGF8vvyzxtFYZXP5X5Hs'
    }
  };